<script setup lang="ts">
import {
  ArticleItem,
  BlogArticleProps,
  TransformedArticle,
  articleTransformer,
  sortArticles,
} from '~/components/cms/BlogArticlePanel/blogArticleHelper'

const props = withDefaults(defineProps<BlogArticleProps>(), {
  showAsCarousel: true,
  limit: 8,
})
const { blogArticles, supportingData, connectedContentPillar, title } = props
const { getEntries } = useContentful()
const categoryToSearch = connectedContentPillar?.fields?.category
const isSortByPublishedDateDesc = supportingData?.home?.Algorithm?.value === 'publishDateDesc'
const orderFilter = isSortByPublishedDateDesc ? { order: '-fields.publishedDate' } : {}
const articles = ref<TransformedArticle[]>([])

if (blogArticles && blogArticles.length) {
  const transformedArticles = articleTransformer(blogArticles)
  articles.value = isSortByPublishedDateDesc ? sortArticles(transformedArticles) : transformedArticles
} else {
  const { data } = await useAsyncData(`RelatedBlogArticlePanel:${categoryToSearch}`, async () => {
    const entries = await getEntries({
      content_type: 'blogArticle',
      'fields.category': categoryToSearch,
      ...orderFilter,
      limit: props.limit,
    })
    if (!entries || !entries.items) {
      return undefined
    }
    return entries.items
  })
  articles.value = articleTransformer(data.value as ArticleItem[])
}
</script>

<template>
  <section class="related-blog-article-list">
    <h3 v-if="title" class="related-blog-article-list__title">{{ title }}</h3>
    <div class="swiper-container" v-if="showAsCarousel">
      <Carousel :items="articles">
        <template #swiperSlide="{ item }">
          <ArticleCard variant="related-article" :item="item" />
        </template>
      </Carousel>
    </div>
    <template v-else>
      <ArticleCard v-for="article in articles" :item="article" variant="featured-article" />
    </template>
  </section>
</template>
<style lang="postcss">
.related-blog-article-list {
  max-width: 80rem;
  margin: 0 auto;
  padding: var(--space-50) var(--space-50) var(--space-100) var(--space-50);

  .related-blog-article-list__title {
    text-align: center;
    font-size: var(--text-xlarge);
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: var(--space-90);
  }

  .blog-article-list__view-all a {
    text-decoration-color: var(--text-primary);
    &:hover {
      color: var(--text-link-hover);
      text-decoration-color: inherit;
    }
  }
}
</style>
